<template>
<div>
    <div class="text-center" style="padding: 2em 0 1em;">
      <img src="/static/imgs/logo.png"/>
    </div>

    <div id="formBox" class="panel panel-primary page">
      <div class="panel-heading">
        <span class="panel-title">Forgot your password?</span>
      </div>

      <form novalidate class="form-horizontal" role="form">
        <div class="panel-body">
          <div class="form-group">
            <input type="email" v-model="email" class="form-control floating-label"
                   data-hint="Enter your email address." placeholder="Email">
          </div>

          {{ error }}
        </div> <!-- .panel-body -->

        <div class="panel-footer zztext-right">
          <a class="btn btn-warning" href="" @click.prevent="toggle_reset_request">Login</a>
          <button type="submit" class="btn btn-primary pull-right" @click="send_forgot">Reset Password</button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>
  export default {
    data() {
      return {
        email: "",
        error: "",
      }
    },
    methods: {
      async send_forgot() {
        let reset = null;
        try {
          reset = await (await this.$http.post("/api/reset/request/", {
            email: this.email,
          })).json();
        } catch (e) {
          this.error = (await e.json()).error;
          return;
        }

        if (!reset.success) {
          this.error = reset.error;
        } else {
          this.$store.commit("add_toast", {
            message: "Your password reset has been sent. Please check your emails."
          });
          this.$router.push({name: "login"});
        }
      },
      toggle_reset_request() {
        this.$router.push({name: "login"});
      },
    },
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/ResetRequest.vue?0a67a1f8